import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { useGlobalState } from '@/state'
import classNames from '@/utils/classNamesLocal'
import { missingItems } from '@/pages/Users/ProfileCompletion'

const TABS = [
  { name: 'Profile', url: '/profile', tab: 'profile' },
  { name: 'My work', url: '/profile/work', tab: 'work' },
  { name: 'Visibility', url: '/profile/visibility', tab: 'visibility' }
]

// Three tabs, visible at every width. The badge is how many checklist items
// are still open on that tab.
export default function ProfileTabs () {
  const [user] = useGlobalState('userContainerUser')
  const location = useLocation()
  const history = useHistory()
  if (!user) { return null }
  const missing = missingItems(user)

  return <div className='border-b border-gray-200 dark:border-gray-700'>
    <nav className='-mb-px flex gap-x-1 overflow-x-auto' aria-label='Profile sections' style={{ scrollbarWidth: 'thin' }}>
      { TABS.map((t) => {
        const selected = location.pathname === t.url || (t.url === '/profile' && location.pathname === '/profile/general')
        const count = missing.filter((m) => m.tab === t.tab).length
        return <button key={t.url} type='button' onClick={() => history.push(t.url)} aria-current={selected ? 'page' : undefined}
          className={classNames('whitespace-nowrap rounded-t-md border-b-2 px-3 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-cccblue',
            selected ? 'border-cccblue text-cccblue' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white')}>
          {t.name}
          { count > 0 && <span className={classNames('ml-2 rounded-full px-2 py-0.5 text-xs font-semibold', selected ? 'bg-cccblue text-white' : 'bg-cccorange/15 text-cccorange')}>{count}</span> }
        </button>
      })}
    </nav>
  </div>
}
